﻿import React, { Component } from 'react';
import axios from 'axios';
import config from '../config';
import HeaderImage from '../images/header.png';
import 'semantic-ui-css/semantic.min.css';
import '../index.css';
import './reports.css';
import { Grid, Divider, Image } from 'semantic-ui-react';
import { Footer } from '../layout/footer';
//Use d3 components to make graphs.
var d3 = require('d3');

export default class PQIGraph extends Component {

    constructor(props) {
        super(props);
        this.state = {
            //current county that is selected
            agencyId: props['data'],
            agencyName: 'N.A',
            //set the current year
            selectedYear: new Date().getFullYear(), 

            //Change the number here to set how many
            //years in the future you want to see
            //data trends.
            projectedYears: 10,

            //This array will store the psr table as objects.
            //Change this value, to change the data the graph uses.
            graphData: []

        };
        
        //Call this in the constructor since this gets performed first
        this.fetchPsrData(this.state.agencyId, this.state.selectedYear, this.state.projectedYears);
    }

    
    //Use axios to make a request to the server to get the agency name
    //from the table, then update the state of the agencyName variable.
    fetchAgencyName(agencyId) {
    axios.get(`${config.server}\\agencyName\\${agencyId}`)
         .then((res) => {
            let data = res.data.result[0];
            this.setState({
                agencyName: data.Name
            });

        }).catch(function (error) {
                console.log("ERROR in fetchAgencyName: " + error);   
        })
}

    // Get the psr data table by passing parameters of agencyId, year, 
    // and number of years out the user wants to view.
    fetchPsrData = (agencyId, selectedYear, projectedYears) => {
       axios.get(`${config.server}\\psrData\\${agencyId}\\${selectedYear}\\${projectedYears}`)
            .then((res) => {
                let data = res.data.result;

                for ( var i = 0; i < data.length; i++) {

                    //store the data
                    let year = data[i].selectedYear;

                    //convert from decimal to percentage
                    let goodRange = data[i].goodRange * 100;
                    let fairRange = data[i].fairRange * 100;
                    let poorRange = data[i].poorRange * 100;

                    //round to 1 decimal place
                    let roundGoodRange = Math.round(goodRange * 10) / 10;
                    let roundFairRange = Math.round(fairRange * 10) / 10;
                    let roundPoorRange = Math.round(poorRange * 10) / 10;

                    //create an object based off the data
                    var column = {
                        year: year.toString(), 
                        goodRange: roundGoodRange.toString(),
                        fairRange: roundFairRange.toString(), 
                        poorRange: roundPoorRange.toString()
                    };

                    //Add the object to the graphData array
                    this.setState({ 
                        graphData: this.state.graphData.concat([column])
                    });
                }

                //build the graph based of the data
                this.renderBarGraph();

            })
            .catch(function (error) {
                console.log("ERROR in fetchPsrData: " + error);
            })
    }

    render() {
        return (
            <div>

                <Grid stackable relaxed centered style={{ height: '100%', margin: 0, width:'100%' }} columns={1} >
                    <Grid.Column width={12}
                        style={{
                            backgroundColor: 'white',
                            border: '1px none #CCCCCC',
                            borderLeftStyle: 'solid',
                            borderRightStyle: 'solid',
                            position: 'relative',
                            margin: '0',
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: '100vh',
                }}>

                        {/* Header portion */}
                        <Grid.Row >
                            <Image style={{ margin: 'auto' }} src={HeaderImage} />
                        </Grid.Row>
                       
                        <h2> {this.state.agencyName} County </h2>

                        {/*line divider*/}
                        <Grid.Row>
                            <Divider/>
                        </Grid.Row>

                        {/*Graph gets rendered here*/}
                        <Grid.Row style={{width:'100%'}}>                          
                            <div id="container">
                                <div id="chart" 
                                     style={{ 
                                        textAlign: 'center'
                                    }}>
                                </div>
                            </div>
                        </Grid.Row>
                    
                        {/*Insert footer component*/}
                        <Grid.Row>
                            {<Footer />}
                        </Grid.Row>

                    </Grid.Column>
                </Grid>
            </div>
        );
    }
        //Create the stacked bar graph.
        renderBarGraph() {

            try{

                var margin = { top: 15, right: 15, bottom: 50, left: -23 };

                var width = 1000,
                    height = 700;

                var svg = d3.select("div#container")                   
                    .append("svg")
                    .attr("preserveAspectRatio", "xMinYMin meet")
                    .attr("viewBox", "-120 0 1200 800")
                    .append("g")
                    .classed("svg-content", true)
                    .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
                    .attr("class", "label");

                var data = this.state.graphData;

                var parse = d3.time.format("%Y").parse;

                // Transpose the data into layers
                var dataset = d3.layout.stack()(["goodRange", "fairRange", "poorRange"]
                    .map(function (PQI) {
                    return data.map(function (d) {
                        return { x: parse(d.year), y: + d[PQI] };
                    });
                }));

                // Set x, y 
                var x = d3.scale.ordinal()
                    .domain(dataset[0].map(function (d) { return d.x; }))
                    .rangeRoundBands([10, width], 0.30);

                var y = d3.scale.linear()
                    .domain([0, d3.max(dataset, function (d) { return d3.max(d, function (d) { return d.y0 + d.y; }); })])
                    .range([height, 20]);

                //set colors for stacked bars
                var colors = ["#006400", "orange", "#8b0000"];

                // Define and draw axes
                var yAxis = d3.svg.axis()
                    .scale(y)
                    .orient("left")
                    .ticks(20)
                    .tickSize(-width, 0, 0)
                    .tickFormat(function (d) { return d });

                var xAxis = d3.svg.axis()
                    .scale(x)
                    .orient("bottom")
                    .tickFormat(d3.time.format("%Y"));

                svg.append("g")
                    .attr("class", "y axis")
                    .attr("font-size", "1.3em")
                    .call(yAxis);

                svg.append("g")
                    .attr("class", "x axis")
                    .attr("transform", "translate(0," + height + ")")
                    .attr("font-size", "1.3em")
                    .call(xAxis);

                //title
                svg.append("text")
                    .attr("x", 500)
                    .attr("y", 5)
                    .attr("text-anchor", "middle")
                    .style("font-size", "2em")  
                    .style("margin-bottom","25px")                                  
                    .text("PQI Graph");

                //label for the x-axis
                svg.append("text")
                    .attr("x", 500)
                    .attr("y", 760)
                    .style("text-anchor", "middle")
                    .attr("font-size", "2em")                   
                    .style("margin-top","25px")
                    .text("Years");

                //label for the y-axis
                svg.append("text")
                    .attr("x", -300)
                    .attr("y", -90)
                    .style("text-anchor", "middle")
                    .attr("transform", "rotate(-90)")
                    .attr("dy", "1.5em")
                    .style("text-anchor", "middle")
                    .attr("font-size", "2em")
                    .text("Percent of Miles");

                // Create groups for each series, rects for each segment 
                // eslint-disable-next-line
                var groups = svg.selectAll("g.cost")
                    .data(dataset)
                    .enter().append("g")
                    .attr("class", "cost")
                    .style("fill", function (d, i) { return colors[i]; });


                // Draw legend
                var legend = svg.selectAll(".legend")
                    .data(colors)
                    .enter().append("g")
                    .attr("class", "legend")
                    
                    .attr("transform", function (d, i) { return "translate(30," + i * 19 + ")"; });

                legend.append("rect")
                    .attr("x", width - 18)
                    .attr("width", 18)
                    .attr("height", 18)
                    .style("fill", function (d, i) { return colors.slice().reverse()[i]; });

                legend.append("text")
                    .attr("x", width + 5)
                    .attr("y", 5)
                    .attr("dy", ".55em")
                    .attr("font-size", "1.3em")
                    .style("text-anchor", "start")
               
                    .text(function (d, i) {
                        // eslint-disable-next-line
                        switch (i) {
                            case 0: return "0.5 - 2.3";
                            case 1: return "2.3 - 3.5";
                            case 2: return "> 3.5";
                        }
                    });

                // Prep the tooltip bits, initial display is hidden
                var tooltip = svg.append("g")
                    .attr("class", "tooltip")
                    .style("display", "none");

                tooltip.append("rect")
                    .attr("width", 30)
                    .attr("height", 20)
                    .attr("fill", "white")
                    .style("opacity", 0.5);

                tooltip.append("text")
                    .attr("x", 15)
                    .attr("dy", "1.2em")
                    .style("text-anchor", "middle")
                    .attr("font-size", "1em")
                    .attr("font-weight", "bold");
            }
        catch(error) {
            console.log("Error in render Bar Graph: " + error);
        }
    }

    componentDidMount() {
        this.fetchAgencyName(this.state.agencyId);
    }

}//end of the component



// WEBPACK FOOTER //
// ./src/reports/pqi-graph.js